import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './Components/header';
import Banner from './Components/banner';
import Footer from './Components/footer'; 
import ScrollSpy from 'react-ui-scrollspy';
import WebModal from './Components/common/web-modal';
import ThankYouModal from './Components/modals/thankyou';
import Service from './Components/service';
import IntegrateSer from './Components/integration';
import Industries from './Components/industry';
import RelatedService from './Components/relatedservices';
import HireUs from './Components/bannerblu';
import OurWork from './Components/ourwork';
import FootContact from './Components/gettowork';
import IndustrySlide from './Components/industryslider';
 
const App = () => {
  const [webModal, setWebModal] = useState(false);
  const [thankModal, setThankModal] = useState(false);
  const [customHeading, setCustomHeading] = useState("default");

  const toggleWebModal = (heading) => {
    setCustomHeading(heading || "default");
    setWebModal(!webModal);
  };

  const toggleThankModal = () => {
    setThankModal(!thankModal);
  };

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
      mirror: false,
      offset: 100,
      anchorPlacement: 'top-bottom',
      disable: 'mobile'
    });    
  }, []);

  return (
    <>
      <Header toggleModal={() => toggleWebModal("default")} />
      <WebModal modal={webModal} toggleModal={() => toggleWebModal(customHeading)} customHeading={customHeading} />
      <ThankYouModal modal={thankModal} toggleModal={toggleThankModal} />
      <ScrollSpy scrollThrottle={100} useBoxMethod={false}>        
      <Banner id="banner" setThankModal={setThankModal} toggleModal={() => toggleWebModal("default")} />
      <Service id="service" toggleModal={() => toggleWebModal("default")}/>
      <IntegrateSer id="intigrate" toggleModal={() => toggleWebModal("default")}/>
      {/* <Industries id="industry" toggleModal={() => toggleWebModal("default")} /> */}
      <IndustrySlide id="industry" toggleModal={() => toggleWebModal("default")}/>  
      <RelatedService id="relservice" toggleModal={() => toggleWebModal("default")}/>
      <HireUs  id="hireus" toggleModal={() => toggleWebModal("default")}/>
      <OurWork/>
      <FootContact/>     
      </ScrollSpy>
      <Footer />
    </>
  );
};

export default App;
